export const ANALYTICS_MORE_FILTER_ID = "more-filter-select__analytics";

export { MultipleSelect as Multiple } from "./Multiple";
